/*eslint-disable*/ export const messages = {
    Apply: "Anwenden",
    "Changed the date": "Datum geändert",
    Clear: "Löschen",
    "Date picker open, choose a date": "Datumsauswahl geöffnet, Datum auswählen",
    "Date range picker open, select a date range": "Datumsbereichsauswahl geöffnet, Datumsbereich auswählen",
    "End Date": "Enddatum",
    "Please enter a valid date ({format})": ["Geben Sie ein gültiges Datum ein (", ["format"], ")"],
    "Please select a date after {minDate}": ["Wählen Sie ein Datum nach dem ", ["minDate"], " aus"],
    "Please select a date before {maxDate}": ["Wählen Sie ein Datum vor dem ", ["maxDate"], " aus"],
    "Show next month": "Nächsten Monat anzeigen",
    "Show previous month": "Letzten Monat anzeigen",
    "Start Date": "Startdatum",
    "The selected date is disabled": "Das ausgewählte Datum ist deaktiviert",
    "The selected date is unavailable. Please select another.":
        "Das ausgewählte Datum ist nicht verfügbar. Bitte treffen Sie eine andere Auswahl.",
    Today: "Heute",
    "Today, {dateStr}": ["Heute, ", ["dateStr"]],
    "date picker": "Datumsauswahl",
    "start date selected": "Startdatum ausgewählt",
    to: "bis",
    "{dateStr}, select end date": [["dateStr"], ", Enddatum auswählen"],
    "{dateStr}, select start date": [["dateStr"], ", Startdatum auswählen"],
    "{startDate} to {endDate}, choose apply to confirm, or cancel": [
        ["startDate"],
        " bis ",
        ["endDate"],
        ", Zum Bestätigen „Anwenden“ auswählen oder abbrechen",
    ],
};
